import { createFileRoute } from '@tanstack/react-router';

import { TaxiGroundTransferPage } from '@/features/groundTransfer/TaxiGroundTransferPage';

export const Route = createFileRoute(
	'/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId',
)({
	component: RouteComponent,
});

function RouteComponent() {
	const {
		missionId,
		searchId,
		mobilitySolutionId,
		groundTransferId,
		bookingId,
	} = Route.useParams();

	return (
		<TaxiGroundTransferPage
			missionId={missionId}
			searchId={searchId}
			mobilitySolutionId={mobilitySolutionId}
			groundTransferId={groundTransferId}
			bookingId={bookingId}
		/>
	);
}
